import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FieldPrefix } from '@shared/model/project';

@Injectable({
  providedIn: 'root',
})
export class ValidationsService {
  private _baseUrl: string = `${environment.apiUrl}/projects/project-fields`;

  constructor(private _http: HttpClient) {}

  getValidators(model: FieldPrefix): Observable<any> {
    return this._http.get(`${this._baseUrl}/?model=${model}/`);
  }
}
